import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NavigationExtras, Router, ActivatedRoute } from "@angular/router";
import { AccountDebtor } from '../models/account.model';
import { GetUserAccountDebtorGQL } from '../generated/cloudapigql';
import { SwitchAccountDebtorGQL } from '../generated/accountgql';
import { StorageType, AuthenticationService } from "./authentication.service";
import { HeaderService } from './header.service';
import { SocketIoService } from './socketio.service';


@Injectable()
export class AccountDebtorService {
  AccountDebtors: AccountDebtor[] = [];

  CurrentAccountDebtor:AccountDebtor;

  AccountDebtorSubscription: BehaviorSubject<AccountDebtor> = new BehaviorSubject(new AccountDebtor());

  constructor(
    private getUserAccountDebtorGQL: GetUserAccountDebtorGQL,
    private switchAccountDebtorGQL: SwitchAccountDebtorGQL,
    private authService: AuthenticationService,
    private _socketService: SocketIoService,
    ) {
  }

 initAccountDebtor(){
    this.getAccountDebtor();
 }

 private getAccountDebtor() {
    this.getUserAccountDebtorGQL.fetch().subscribe(
      (result) => {
        this.AccountDebtors = result.data.getUserAccountDebtor;
        this.CurrentAccountDebtor = this.AccountDebtors.find(y=>y.accountId==this.authService.userContext.accountId && y.lDebtorId==this.authService.userContext.debtorId);
      }
    );
  }

  switchAccountDebtor(accountId:string,debtorId:number){
    this._socketService.socketDisconnection();
    this.switchAccountDebtorGQL.mutate({
        accountId:accountId,
        debtorId:debtorId
    }).subscribe(x=>{
        // set new token to session
        sessionStorage.setItem(StorageType.ACCESS, x.data.switchAccountDebtor);
        this.authService.reInitTokenDetails();
        this.setCurrentAccountDebtor();
        this._socketService.setupSocketConnection();

    });
  }

  setCurrentAccountDebtor(){
        this.CurrentAccountDebtor = this.AccountDebtors.find(y=>y.accountId==this.authService.userContext.accountId && y.lDebtorId==this.authService.userContext.debtorId);
        this.AccountDebtorSubscription.next(this.CurrentAccountDebtor);
    }

}
